import { render } from "./app-provider.vue?vue&type=template&id=431bdd15"
import script from "./app-provider.vue?vue&type=script&lang=js"
export * from "./app-provider.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alvar\\OneDrive\\Kaggle\\Vue\\pro_vouchers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__